export default __webpack_public_path__ + "static/media/gallery-10-3.9d31f042.webp";